import axios from "axios";

export default function SubscriptionPreparePayService(formData) {

  return axios({
    method: 'get',
    url: process.env.REACT_APP_SUBSCRIPTION_API_HOST + "/subscription_prepare_to_pay",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
